import { appliedOriginCity } from './originCity'

// The one place a client query derives its drive-time scope from the
// applied filters — the server resolves the identical origin for the
// filter, the eligibility and the card minutes
const driveTimeScope = (filters: GQL_SearchFilters): GQL_DriveTimeScope => ({
  country: filters.country,
  state: filters.state,
  regions: filters.regions,
  originCitySlug: appliedOriginCity(filters.originCity),
  sw: filters.sw,
  ne: filters.ne,
})

export default driveTimeScope
